import * as React from "react";
import { forwardRef } from "react";
const SvgCargoCart = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ React.createElement("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props
}, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", {
	d: "M16.0554 7.82962L11.2258 9.12372C10.1589 9.4096 9.5257 10.5063 9.81158 11.5732L9.99077 12.2419L10.0704 12.5391C10.3563 13.6061 11.453 14.2392 12.5199 13.9533L16.7976 12.8071L17.3495 12.6593C18.4165 12.3734 19.0496 11.2767 18.7637 10.2098L18.5049 9.24384C18.219 8.17691 17.1224 7.54374 16.0554 7.82962Z",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M12.8297 3.51765L9.38595 4.4404C8.31902 4.72628 7.68586 5.82296 7.97174 6.88989L8.15092 7.55861L8.23056 7.85582C8.51644 8.92275 9.61312 9.55591 10.68 9.27003L13.9678 8.38908L14.1238 8.34728C15.1907 8.0614 15.8239 6.96472 15.538 5.89779L15.2792 4.93187C14.9933 3.86493 13.8966 3.23177 12.8297 3.51765Z",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M18.1463 15.0179L10.7028 17.0124C10.2574 17.1317 10.0344 17.1915 9.82978 17.1614C9.82978 17.1614 9.47883 17.0599 9.33814 16.9438C9.18044 16.8136 9.07671 16.6109 8.8714 16.2095C8.27393 14.8005 3.49963 3.99999 3.49963 3.99999L0.999844 5.1184M10.4882 21.211C9.42128 21.4969 8.32461 20.8637 8.03873 19.7968C7.75284 18.7298 8.38601 17.6332 9.45294 17.3473C10.5199 17.0614 11.6165 17.6946 11.9024 18.7615C12.1883 19.8284 11.5551 20.9251 10.4882 21.211Z",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}));
const ForwardRef = forwardRef(SvgCargoCart);
export default ForwardRef;
